import { render } from "./SearchSuggestion.vue?vue&type=template&id=8c3ec122&scoped=true"
import script from "./SearchSuggestion.vue?vue&type=script&lang=js"
export * from "./SearchSuggestion.vue?vue&type=script&lang=js"

import "./SearchSuggestion.vue?vue&type=style&index=0&id=8c3ec122&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c3ec122"]])

export default __exports__